/* eslint-disable */
import styled from 'styled-components';
import { Modal } from 'ggApp/modules/modal/components/v3';

const MODAL_CONTAINER_CLASS_NAME = 'ProductSharerContainer';
const MODAL_CONTENT_CLASS_NAME = 'ProductSharerContent';

export const StyledModal = styled(Modal).attrs({
    classNames: {
        container: MODAL_CONTAINER_CLASS_NAME,
        content: MODAL_CONTENT_CLASS_NAME,
    },
})`
  & .${MODAL_CONTAINER_CLASS_NAME} {
    width: 284px;
    ${props => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        width: 80%;
        min-height: unset;
        min-width: unset;
    `};
  }
  
  & .${MODAL_CONTENT_CLASS_NAME} {
      padding: unset; 
  }
`;
